import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'

const INVALIDATION_KEYS_BY_SCOPE = {
  samples: [
    ['samples'],
    ['sampleLocations'],
    ['observations'],
    ['uniqueSpecies'],
    ['relevantSources'],
  ],
  sightings: [
    ['sightings'],
    ['uniqueSpecies'],
    ['relevantSources'],
    ['sources'],
  ],
  missionData: [
    ['env'],
    ['breeding'],
    ['alerts'],
    ['alerts-all'],
    ['sources'],
  ],
}

const QUERY_KEYS_BY_MISSION_DATA_GROUP = {
  alert: [
    ['alerts'],
    ['alerts-all'],
    ['sources', null, 'alert'],
  ],
  breeding: [
    ['breeding'],
    ['sources', null, 'breeding'],
  ],
  env: [
    ['env'],
    ['sources', null, 'env'],
  ],
  labResults: [
    ['sources', null, 'labResults'],
  ],
}

function queryKeyMatchesPrefix(queryKey, prefix) {
  return prefix.every((prefixPart, index) => prefixPart === null || queryKey[index] === prefixPart)
}

function queryKeyMatchesMission(queryKey, missions) {
  if (missions.length === 0 || queryKey.length < 2) return true

  return missions.map(String).includes(String(queryKey[1]))
}

function getInvalidationKeys({ scope, groups }) {
  const normalizedGroups = Array.isArray(groups) ? groups : [groups].filter(Boolean)

  if (scope !== 'missionData' || normalizedGroups.length === 0) {
    return INVALIDATION_KEYS_BY_SCOPE[scope] || []
  }

  return normalizedGroups.flatMap(group => QUERY_KEYS_BY_MISSION_DATA_GROUP[group] || [])
}

function WebSocketQueryInvalidator() {
  const queryClient = useQueryClient()

  useEffect(() => {
    const handleSourceUpdated = (event) => {
      const { scope, groups = [], missions: changedMissions = [] } = event.detail || {}
      const missions = Array.isArray(changedMissions) ? changedMissions : [changedMissions].filter(Boolean)
      const queryKeys = getInvalidationKeys({ scope, groups })

      queryClient.refetchQueries({
        type: 'active',
        predicate: (query) => {
          return queryKeys.some((queryKey) => {
            return queryKeyMatchesPrefix(query.queryKey, queryKey) && queryKeyMatchesMission(query.queryKey, missions)
          })
        },
      })
    }

    window.addEventListener('ws:source-updated', handleSourceUpdated)

    return () => {
      window.removeEventListener('ws:source-updated', handleSourceUpdated)
    }
  }, [queryClient])

  return null
}

export default WebSocketQueryInvalidator
